import React, { useEffect, useState } from 'react'
import { awsRequirementsLink } from '../../../../common/utils/constants'
import { FormikProps, useFormikContext } from 'formik'
import {
  FlyoutProductSections,
  FlyoutProductAddEditSectionName,
} from '../../../../types/addEditProduct'

import { FlyOutProductAdhere } from '../../../AddEditProductFormComponents/FlyOutProductAdhere/FlyOutProductAdhere'
import { useStyles } from './FlyoutProductDimensionsSection.styles'
import { FormLockedType } from '../../../../types/FormLockedType'
import { FlyOutProductDimensionsPurchasingOptions } from '../../../AddEditProductFormComponents/FlyOutProductDimensionsPurchasingOptions/FlyOutProductDimensionsPurchasingOptions'
import { PlanType } from '@labrav/react-components'
import { FlyOutProductOfferAvailabilityByCountry } from '../../../AddEditProductFormComponents/FlyOutOfferAvailabilityByCountry/FlyOutProductOfferAvailabilityByCountry'
import { isEmpty } from 'lodash'
import { ContractDimensions } from '../../../AddEditProductFormComponents/ContractDimensions/ContractDimensions'
import { UsageDimensions } from '../../../AddEditProductFormComponents/UsageDimensions/UsageDimensions'
import { fetchAwsDimensionsCategoriesList } from '../../../../common/api/index'
import { ProductFreeTrial } from '../../../AddEditProductFormComponents/ProductFreeTrial/ProductFreeTrial'
import { useFlag } from '@labrav/flags'

export type AwsDimensionUnitType = {
  label: string
  value: string
}
export type AwsDimensionCategories = {
  contract: AwsDimensionUnitType[]
  subscription: AwsDimensionUnitType[]
  usageMap: Record<string, string>
}
export const initialAwsDimensionCategories: AwsDimensionCategories = {
  contract: [],
  subscription: [],
  usageMap: {},
}

type FlyoutProductDimensionsSection = {
  detailView?: boolean
  detailViewTooltip?: string
  productView?: boolean
  awsDimensionCategoriesProps?: AwsDimensionCategories
}

export const FlyoutProductDimensionsSection: React.FC<
  FormLockedType & FlyoutProductDimensionsSection
> = ({
  isFormLocked,
  detailView,
  detailViewTooltip,
  productView,
  awsDimensionCategoriesProps,
}) => {
  const { classes } = useStyles()
  const { values } = useFormikContext() as FormikProps<FlyoutProductSections>

  const { flag: isFreeTrialProductEnable } = useFlag('freeTrialInProduct')

  const [awsDimensionCategories, setAwsDimensionCategoriesList] =
    useState<AwsDimensionCategories>(
      awsDimensionCategoriesProps || initialAwsDimensionCategories
    )
  const [loading, setLoading] = useState<boolean>(productView ? false : true)

  const productType = values.productDetails.productType
  const isProfessionalService = productType === PlanType.PROFESSIONAL_SERVICES
  const requirementsLink = isProfessionalService ? '' : awsRequirementsLink

  const isProductTypeSelected = !isEmpty(values.productDetails.productType)

  const isSaasSubscription = productType === PlanType.SAAS_SUBSCRIPTION

  useEffect(() => {
    if (!productView) {
      setLoading(true)
      fetchAwsDimensionsCategoriesList()
        .then(response => {
          const { usage_map, ...rest } = response.data
          setAwsDimensionCategoriesList({
            ...rest,
            usageMap: usage_map,
          })
          setLoading(false)
        })
        .catch(error => {
          console.error('Failed to fetch list:', error)
          setLoading(false)
        })
    }
  }, [productView])

  if (loading) {
    return <></>
  }

  return (
    <div className={classes.container}>
      <FlyOutProductDimensionsPurchasingOptions
        requirementsLink={requirementsLink}
        awsDimensionCategories={awsDimensionCategories}
        isFormLocked={isFormLocked}
        detailView={detailView}
        detailViewTooltip={detailViewTooltip}
        productView={productView}
      />
      {isProductTypeSelected && (
        <>
          {!isSaasSubscription && (
            <ContractDimensions
              requirementsLink={requirementsLink}
              isFormLocked={isFormLocked}
              awsDimensionCategories={awsDimensionCategories}
              detailView={detailView}
              detailViewTooltip={detailViewTooltip}
              productView={productView}
            />
          )}
          <UsageDimensions
            requirementsLink={requirementsLink}
            isFormLocked={isFormLocked}
            isSaasSubscription={isSaasSubscription}
            awsDimensionCategories={awsDimensionCategories}
            detailView={detailView}
            detailViewTooltip={detailViewTooltip}
            productView={productView}
          />
        </>
      )}
      <FlyOutProductOfferAvailabilityByCountry
        requirementsLink={requirementsLink}
        isFormLocked={isFormLocked}
        detailView={detailView}
        detailViewTooltip={detailViewTooltip}
      />
      {isFreeTrialProductEnable?.value &&
        !productView &&
        !isSaasSubscription && <ProductFreeTrial />}
      {!productView && (
        <FlyOutProductAdhere
          requirementsLink={requirementsLink}
          sectionName={FlyoutProductAddEditSectionName.PRODUCT_DIMENSIONS}
          isFormLocked={isFormLocked}
        />
      )}
    </div>
  )
}
